import React, { useState } from 'react';
import './OurTeam.css';

const OurTeam = () => {
  const [selectedMember, setSelectedMember] = useState(null);

  const teamMembers = [
    {
      id: 1,
      name: "Dr. Muhammad Junaid",
      position: "Chief Dentist & Clinic Owner",
      specialization: "Orthodontics, Endodontics & Implantology",
      experience: "10+ Years",
      education: [
        "BSc - Punjab University (PU)",
        "BDS - FMH College of Medicine and Dentistry",
        "FCICSD - Fellowship at California Institute of Cosmetic and Surgical Dentistry"
      ],
      achievements: [
        "Certified Orthodontist",
        "Certified Endodontist", 
        "Certified Implantologist",
        "Associate Dentist at California Care Dental",
        "Studied at California Institute of Cosmetic and Surgical Dentistry"
      ],
      image: "https://images.unsplash.com/photo-1612349317150-e413f6a5b16d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      bio: "Dr. Muhammad Junaid is the founder and chief dentist at Prime Care Dental. He holds a BSc from Punjab University and BDS from FMH College of Medicine and Dentistry. With his Fellowship from California Institute of Cosmetic and Surgical Dentistry (FCICSD), he brings international expertise to Lahore. As a certified orthodontist, endodontist, and implantologist, Dr. Junaid provides comprehensive dental care with advanced techniques learned from his experience as an Associate Dentist at California Care Dental.",
      languages: ["English", "Urdu", "Punjabi"],
      availableDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"]
    },
    {
      id: 2,
      name: "Dr. Sarah Ahmed",
      position: "Associate Dentist",
      specialization: "Pediatric Dentistry & Preventive Care",
      experience: "6+ Years",
      education: [
        "BDS - Dow University of Health Sciences",
        "Certificate in Pediatric Dentistry",
        "Preventive Dentistry Training"
      ],
      achievements: [
        "Pediatric Dentistry Specialist",
        "500+ Children Treated",
        "Gentle Care Expert",
        "Preventive Care Advocate"
      ],
      image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      bio: "Dr. Sarah Ahmed specializes in pediatric dentistry and preventive care. She is known for her gentle approach with children and expertise in maintaining optimal oral health for patients of all ages.",
      languages: ["English", "Urdu"],
      availableDays: ["Monday", "Wednesday", "Friday", "Saturday"]
    },
    {
      id: 3,
      name: "Ayesha Khan",
      position: "Senior Dental Hygienist",
      specialization: "Oral Hygiene & Dental Cleaning",
      experience: "8+ Years",
      education: [
        "Diploma in Dental Hygiene",
        "Scaling & Polishing Certification",
        "Oral Health Education Training"
      ],
      achievements: [
        "Expert in Professional Cleaning",
        "Oral Health Educator",
        "Patient Comfort Specialist",
        "Quality Care Provider"
      ],
      image: "https://images.unsplash.com/photo-1551190822-a9333d879b1f?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80",
      bio: "Ayesha Khan is our senior dental hygienist with over 8 years of experience in providing excellent oral hygiene care. She specializes in professional cleaning and educating patients about maintaining optimal oral health.",
      languages: ["English", "Urdu", "Punjabi"],
      availableDays: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    }
  ];

  const openModal = (member) => {
    setSelectedMember(member);
  };

  const closeModal = () => {
    setSelectedMember(null);
  };

  return (
    <section className="our-team-section" id="our-team">
      <div className="team-container">
        {/* Header */}
        <div className="team-header">
          <div className="team-badge">
            <svg className="badge-icon" viewBox="0 0 24 24" fill="currentColor">
              <path d="M12 2L13.09 8.26L22 9L13.09 9.74L12 16L10.91 9.74L2 9L10.91 8.26L12 2Z"/>
            </svg>
            <span>Expert Medical Team</span>
          </div>
          
          <h2 className="team-title">
            Meet Our Professional 
            <span className="title-highlight"> Dental Team</span>
          </h2>
          
          <p className="team-description">
            Our experienced team of dental professionals is dedicated to providing exceptional dental care at Prime Care Dental. 
            Led by Dr. Muhammad Junaid, we combine years of expertise with the latest technology to ensure the best possible outcomes for our patients.
          </p>
        </div>

        {/* Team Grid */}
        <div className="team-grid">
          {teamMembers.map((member, index) => (
            <div 
              key={member.id} 
              className={`team-card ${index === 0 ? 'featured-member' : ''}`}
              onClick={() => openModal(member)}
            >
              <div className="member-image-container">
                <img 
                  src={member.image} 
                  alt={member.name}
                  className="member-image"
                />
                {index === 0 && (
                  <div className="owner-badge">
                    <svg className="crown-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M5 16L3 5L7 8L12 2L17 8L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"/>
                    </svg>
                    <span>Clinic Owner</span>
                  </div>
                )}
                <div className="member-overlay">
                  <div className="overlay-content">
                    <div className="experience-badge">
                      {member.experience}
                    </div>
                    <div className="view-profile">
                      <svg viewBox="0 0 24 24" fill="currentColor">
                        <path d="M12 9C13.65 9 15 7.65 15 6C15 4.35 13.65 3 12 3C10.35 3 9 4.35 9 6C9 7.65 10.35 9 12 9M12 11C9.79 11 6 12.1 6 14.25V15C6 15.55 6.45 16 7 16H17C17.55 16 18 15.55 18 15V14.25C18 12.1 14.21 11 12 11M19 3H23V5H19V3M19 7H21V9H19V7M17 7H19V9H17V7Z"/>
                      </svg>
                      <span>View Profile</span>
                    </div>
                  </div>
                </div>
              </div>
              
              <div className="member-info">
                <h3 className="member-name">{member.name}</h3>
                <p className="member-position">{member.position}</p>
                <p className="member-specialization">{member.specialization}</p>
                
                <div className="member-highlights">
                  <div className="highlight-item">
                    <svg className="highlight-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2C6.48 2 2 6.48 2 12S6.48 22 12 22 22 17.52 22 12 17.52 2 12 2M10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"/>
                    </svg>
                    <span>{member.experience} Experience</span>
                  </div>
                  <div className="highlight-item">
                    <svg className="highlight-icon" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 3L1 9L12 15L21 10.09V17H23V9M5 13.18V17.18L12 21L19 17.18V13.18L12 17L5 13.18Z"/>
                    </svg>
                    <span>
                      {member.id === 1 ? 'BDS (FMH), FCICSD' : 
                       member.id === 2 ? 'BDS (DUHS)' : 
                       'Certified Hygienist'}
                    </span>
                  </div>
                </div>
                
                {/* Credentials for Dr. Muhammad Junaid */}
                {member.id === 1 && (
                  <div className="credentials-section">
                    <div className="credentials-badges">
                      <span className="credential-badge">C-Ortho</span>
                      <span className="credential-badge">C-Endo</span>
                      <span className="credential-badge">C-Implant</span>
                    </div>
                    <div className="associate-info">
                      <span className="associate-text">Associate Dentist at California Care Dental</span>
                    </div>
                  </div>
                )}
                
                {/* Credentials for Dr. Sarah Ahmed */}
                {member.id === 2 && (
                  <div className="credentials-section">
                    <div className="credentials-badges">
                      <span className="credential-badge pediatric">Pediatric Cert</span>
                      <span className="credential-badge preventive">Preventive Care</span>
                    </div>
                    <div className="associate-info">
                      <span className="associate-text">500+ Children Successfully Treated</span>
                    </div>
                  </div>
                )}
                
                {/* Credentials for Ayesha Khan */}
                {member.id === 3 && (
                  <div className="credentials-section">
                    <div className="credentials-badges">
                      <span className="credential-badge hygienist">Prof. Cleaning</span>
                      <span className="credential-badge educator">Oral Health Ed</span>
                    </div>
                    <div className="associate-info">
                      <span className="associate-text">Scaling & Polishing Certified</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
        
        {/* Background Elements */}
        <div className="team-bg-elements">
          <div className="bg-circle circle-1"></div>
          <div className="bg-circle circle-2"></div>
          <div className="bg-circle circle-3"></div>
        </div>
      </div>

      {/* Team Member Modal */}
      {selectedMember && (
        <div className="team-modal" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41Z"/>
              </svg>
            </button>
            
            <div className="modal-header">
              <div className="modal-image">
                <img src={selectedMember.image} alt={selectedMember.name} />
                {selectedMember.id === 1 && (
                  <div className="modal-owner-badge">
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M5 16L3 5L7 8L12 2L17 8L21 5L19 16H5M19 19C19 19.6 18.6 20 18 20H6C5.4 20 5 19.6 5 19V18H19V19Z"/>
                    </svg>
                    Clinic Owner
                  </div>
                )}
              </div>
              <div className="modal-basic-info">
                <h3 className="modal-name">{selectedMember.name}</h3>
                <p className="modal-position">{selectedMember.position}</p>
                <p className="modal-specialization">{selectedMember.specialization}</p>
                <p className="modal-experience">{selectedMember.experience} Experience</p>
              </div>
            </div>

            <div className="modal-details">
              <div className="modal-bio">
                <h4>About</h4>
                <p>{selectedMember.bio}</p>
              </div>

              <div className="modal-education">
                <h4>Education & Qualifications</h4>
                <ul>
                  {selectedMember.education.map((edu, index) => (
                    <li key={index}>{edu}</li>
                  ))}
                </ul>
              </div>

              <div className="modal-achievements">
                <h4>Key Achievements</h4>
                <ul>
                  {selectedMember.achievements.map((achievement, index) => (
                    <li key={index}>{achievement}</li>
                  ))}
                </ul>
              </div>

              <div className="modal-additional">
                <div className="modal-languages">
                  <h5>Languages</h5>
                  <div className="language-tags">
                    {selectedMember.languages.map((language, index) => (
                      <span key={index} className="language-tag">{language}</span>
                    ))}
                  </div>
                </div>

                <div className="modal-availability">
                  <h5>Available Days</h5>
                  <div className="availability-tags">
                    {selectedMember.availableDays.map((day, index) => (
                      <span key={index} className="availability-tag">{day}</span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default OurTeam; 